import React from 'react';

import { clsx } from 'clsx';
import Header from 'shared/routes/components/layout/Header';
import './layout.css';

type Props = {
  children: React.ReactNode;
};

const Layout = ({ children }: Props) => {
  return (
    <div>
      <Header />
      <div className="flex justify-center px-m">
        <div className={clsx('layout w-full md:w-3/4')}>{children}</div>
      </div>
    </div>
  );
};

export default Layout;
